import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Motion } from 'react-motion';
import moment from 'moment';
import { EMPTY_OBJECT, FULL_STYLE, RESPONSIVE_SIZE } from '../../constants';
import { springify } from '../../lib/Motion';
import { compose } from '../../lib/react';
import { loadImage, PRIORITY } from '../../lib/tasks';
import Aspect from '../Aspect';
import { withHover } from '../Hoverable';
import ImageLoader from '../ImageLoader';
import Video from '../Video';
import Style from '../Style';
import { H4, L4 } from '../Typography';

class ClipThumbnail extends React.PureComponent {
  static propTypes = {
    responsive: PropTypes.number,
    hover: PropTypes.bool,
    title: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string,
    lqip: PropTypes.string,
    thumbnail: PropTypes.string,
    poster: PropTypes.string.isRequired,
    video: PropTypes.string.isRequired,
    colorA: PropTypes.string.isRequired,
    colorB: PropTypes.string.isRequired,
    length: PropTypes.number.isRequired,
    like: PropTypes.node,
    style: PropTypes.object,
  };
  static defaultProps = {
    hover: false,
    like: undefined,
    style: EMPTY_OBJECT,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      videoPlaying: false,
    };
  }

  componentDidMount() {
    this.processNewProps(EMPTY_OBJECT, this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.processNewProps(this.props, nextProps);
  }

  processNewProps = (props, nextProps) => {
    if (nextProps.thumbnail && props.thumbnail !== nextProps.thumbnail) {
      loadImage(nextProps.thumbnail);
    }

    if (props.video !== nextProps.video) {
      this.setState({ videoPlaying: false });
    }
  };

  render() {
    let {
      responsive,
      hover,
      title,
      backgroundColor,
      lqip,
      thumbnail,
      poster,
      video,
      colorA,
      colorB,
      length,
      like,
      style,
      ...otherProps
    } = this.props;

    let titleSize = '2.6rem';
    let titlePadding = '2.5rem';
    let smallTitle = true;

    if (responsive < RESPONSIVE_SIZE.TABLET_LANDSCAPE) {
      titleSize = '2rem';
      titlePadding = '1.5rem';
      if (title.length > 55) {
        title = title.slice(0, 50).trim() + '...';
      }
    }

    if (responsive >= RESPONSIVE_SIZE.TABLET_PORTRAIT) {
      smallTitle = false;
    }

    const backgroundStyle = {
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: Style.Colors.black,
    };
    const linkStyle = {
      display: 'block',
      textDecoration: 'none',
      color: Style.Colors.white,
    };
    const posterStyle = {
      ...FULL_STYLE,
      width: '100%',
    };
    const infoOverlayStyle = {
      ...FULL_STYLE,
      top: undefined,
      height: '33%',
      background: `linear-gradient(to bottom, transparent 0%, ${Style.Colors
        .black} 100%)`,
    };
    const infoContainerStyle = {
      position: 'absolute',
      right: '25%',
      bottom: 0,
      left: 0,
      display: 'flex',
      flexDirection: 'column',
    };
    const titleStyle = {
      // HACK: Not supposed to do this.
      fontSize: titleSize,
      padding: titlePadding,
      position: 'relative',
    };
    const labelStyle = {
      padding: '2.5rem',
      position: 'absolute',
      bottom: 0,
      left: 0,
    };
    const videoStyle = {
      ...FULL_STYLE,
      width: '100%',
    };
    const animatedDefault = {
      shadowSpread: 0,
      labelOpacity: smallTitle ? 0 : 0.5,
      titleOpacity: smallTitle ? 1 : 0,
      titlePosition: smallTitle ? 0 : 1,
      posterOpacity: 1,
    };
    const animatedCurrent = {
      shadowSpread: hover ? 1 : animatedDefault.shadowSpread,
      labelOpacity: hover ? 0 : animatedDefault.labelOpacity,
      titleOpacity: hover ? 1 : animatedDefault.titleOpacity,
      titlePosition: hover ? 0 : animatedDefault.titlePosition,
      posterOpacity:
        hover && this.state.videoPlaying ? 0 : animatedDefault.posterOpacity,
    };
    const clipLength = moment(length).format('m:ss');

    return (
      <Motion defaultStyle={animatedDefault} style={springify(animatedCurrent)}>
        {tween => {
          // Animated properties.
          const labelStyleMerged = {
            ...labelStyle,
            opacity: tween.labelOpacity,
          };
          const titleStyleMerged = {
            ...titleStyle,
            opacity: tween.titleOpacity,
            bottom: `calc(-${244 * tween.titlePosition}px + ${5 *
              tween.titlePosition}rem)`,
          };
          const backgroundStyleMerged = {
            ...backgroundStyle,
            boxShadow: `0 0 0 ${tween.shadowSpread}rem ${colorB}`,
            ...style,
          };
          const posterStyleMerged = {
            ...posterStyle,
            opacity: tween.posterOpacity,
          };

          return (
            <div style={backgroundStyleMerged}>
              <Aspect ratio={9 / 16}>
                <div style={{ color: Style.Colors.white }}>
                  {(hover || tween.posterOpacity < 1) && (
                      <Video
                        onPlaying={e => this.setState({ videoPlaying: true })}
                        onPause={e => this.setState({ videoPlaying: false })}
                        style={videoStyle}
                        src={video}
                      />
                    )}
                  <div style={{ opacity: tween.posterOpacity }}>
                    <ImageLoader
                      color={backgroundColor}
                      lqip={lqip}
                      images={[thumbnail]}
                    />
                  </div>
                  <div style={infoOverlayStyle} />
                  <div style={infoContainerStyle}>
                    <L4 style={labelStyleMerged}>VIEW CLIP • {clipLength}</L4>
                    <H4 style={titleStyleMerged}>{title}</H4>
                  </div>
                </div>
              </Aspect>
            </div>
          );
        }}
      </Motion>
    );
  }
}

function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive,
  };
}

export default compose(withHover(), connect(mapStateToProps))(ClipThumbnail);



// WEBPACK FOOTER //
// ./src/components/ClipThumbnail/ClipThumbnail.js